// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { deleteLogo as deleteLogoApi, DeleteLogoParams } from "@bg/App/Services/CustomQuoteService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface DeleteLogoHandlerParameter {
    customQuoteId: string;
    onSuccess?: (result: any) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<DeleteLogoHandlerParameter, DeleteLogoParams, ServiceResult<any>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        customQuoteId: props.parameter.customQuoteId,
    };
};

export const DeleteLogoCall: HandlerType = async props => {
    props.apiResult = await deleteLogoApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result!);
    }
};

export const chain = [PopulateApiParameter, DeleteLogoCall, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const deleteLogo = createHandlerChainRunner(chain, "DeleteLogo");
export default deleteLogo;
